import { getCurrentInstance, ref, computed } from '@vue/composition-api';

import { priceFormatted } from '@/utils/formatters/formattedPrice';

import { useLocationContext } from '@/compositions/location/locationStorage';

const useBasketSummary = (props) => {
  const { emit } = getCurrentInstance();
  const { isUaOrGb } = useLocationContext();

  const showMnogoRuCard = ref(false);

  const isDisabledOrderButton = computed(() => !!(props.isDeletedAll || isUaOrGb.value || props.unavailableItemsLength));

  const maxPayBonusesAsNumber = computed(() => {
    const asNumber = +props.maxPayBonuses;
    return Number.isNaN(asNumber) ? 0 : asNumber;
  });

  const showPayBonuses = computed(() => maxPayBonusesAsNumber.value && !props.isDeletedAll && !isUaOrGb.value);

  const maxPayBonusesFormatted = computed(() => priceFormatted(maxPayBonusesAsNumber.value, { setFreeText: false }));

  const handlerChangedPromoCode = () => emit('changePromoCode');

  const handlerShowMnogoRuCard = () => {
    showMnogoRuCard.value = true;
  };

  const handlerClickButtonGoCheckout = () => emit('clickButtonGoCheckout');

  return {
    showMnogoRuCard,
    isUaOrGb,
    isDisabledOrderButton,
    showPayBonuses,
    maxPayBonusesAsNumber,
    maxPayBonusesFormatted,
    handlerChangedPromoCode,
    handlerShowMnogoRuCard,
    handlerClickButtonGoCheckout,
  };
};

export default useBasketSummary;
